import { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import update from 'immutability-helper';
import { useNavigate } from 'react-router';
import { enqueueSnackbar } from 'notistack';
import { HTML5Backend } from 'react-dnd-html5-backend';

import theme from '@/constants/theme';
import { routes } from '@/constants/routes';
import useLearningRoutes from '@/context/routes/hook';
import Button from '@/components/input/Button';
import { routesService } from '@/services/routes';
import ReorderRouteCard from '@/components/admin/routes/ReorderRouteCard';

const ReorderRoutes = () => {
  const { routesList, handleReloadRoutes } = useLearningRoutes();
  const navigate = useNavigate();

  const [routesOrder, setRoutesOrder] = useState(routesList);

  const moveRoute = (fromIndex: number, toIndex: number) => {
    setRoutesOrder((prev) => {
      return update(prev, {
        $splice: [
          [fromIndex, 1],
          [toIndex, 0, prev[fromIndex]],
        ],
      });
    });
  };

  const handleSaveOrder = () => {
    const formatedResponse = routesOrder.map((route, index) => ({
      routeId: route.id,
      newOrder: index + 1,
    }));
    routesService.reorder(formatedResponse).then((result) => {
      handleReloadRoutes();
      enqueueSnackbar({
        message: 'Orden guardada correctamente',
        variant: 'success',
      });
    });
  };

  useEffect(() => {
    setRoutesOrder(routesList);
  }, [routesList]);

  return (
    <DndProvider backend={HTML5Backend}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: 16,
          paddingTop: 32,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h1 style={{ color: theme.colors.text.title }}>Rutas</h1>
          <div style={{ display: 'flex', gap: 16 }}>
            <Button variant="danger" onClick={() => navigate(routes.admin.routes.root)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveOrder}>Guardar Orden</Button>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {routesOrder.map((route, index) => (
            <ReorderRouteCard key={route.id} route={route} index={index} moveRoute={moveRoute} />
          ))}
        </div>
      </div>
    </DndProvider>
  );
};

export default ReorderRoutes;
